import { useSelector } from 'react-redux';
import { getSiteMetadata } from 'config/siteMetadata';

/**
 * Custom hook to get site-specific metadata with fallbacks
 * Used across 100+ different sites (downkount.com, bucksti.me, etc.)
 *
 * @returns {Object} Site metadata with defaults
 */
export const useSiteMetadata = () => {
  const configuration = useSelector((state) => state.configuration?.data);
  const hostname = window.location.hostname;
  const origin = window.location.origin;

  // Get all metadata from centralized configuration
  const metadata = getSiteMetadata(configuration);

  return {
    // Core site info
    siteName: metadata.siteName,
    siteDescription: metadata.siteDescription,
    enhancedDescription: metadata.enhancedDescription,
    sportType: metadata.sportType,
    sportLevel: metadata.sportLevel,

    // Team/League specific
    teamName: metadata.teamName,
    leagueName: metadata.leagueName,
    isOneTeam: metadata.isOneTeam,
    isOneLeague: metadata.isOneLeague,
    actionWord: metadata.actionWord,

    // URLs
    hostname,
    origin,
    canonicalBase: origin,

    // Titles
    fullSiteTitle: metadata.siteTitle,
    shortTitle: metadata.siteName,

    // SEO
    keywords: metadata.keywords,
    manifestName: metadata.manifestName,
  };
};
